import * as codec from './codec.js';

function bytesToText(bytes){
 let text='';
 for(const value of bytes){
  if(value===255)break;
  text+=String.fromCharCode(value);
 }
 return text;
}

function decodePayload(type,payload){
 const model=codec.models[type];
 codec.validate(type,payload);
 const keys=[];
 for(let i=0;i<model.keys;i++){
  keys.push({
   key:payload[i],
   func:payload[model.keys+i],
   extra:payload[model.keys*2+i],
   text:bytesToText(payload.slice(model.textOff+i*model.text,model.textOff+(i+1)*model.text)),
   mix:Array.from(payload.slice(model.mixOff+i*5,model.mixOff+(i+1)*5))
  });
 }
 const result={
  type,
  keys,
  lighting:{
   mode:payload[model.lightOff],
   colors:Array.from(payload.slice(model.lightOff+1,model.lightOff+1+model.keys)),
   brightness:payload[model.brightnessOff]
  }
 };
 if(model.knob){
  const mixOffsets=[5,10,0];
  result.knobs=[];
  for(let i=0;i<3;i++){
   const off=model.knobOff+i*3;
   result.knobs.push({
    key:payload[off],func:payload[off+1],extra:payload[off+2],
    mix:Array.from(payload.slice(model.knobMixOff+mixOffsets[i],model.knobMixOff+mixOffsets[i]+5))
   });
  }
 }
 return result;
}

function buildPayload(type,keyResults,lighting,knobs){
 const model=codec.models[type];
 if(!model||!Array.isArray(keyResults)||keyResults.length!==model.keys)throw Error('配置型号或按键数量不匹配');
 const payload=new Uint8Array(model.length).fill(255);
 keyResults.forEach((item,i)=>{
  if(!item)throw Error('按键 '+(i+1)+' 的配置不完整');
  payload[i]=item.keyCode;
  payload[model.keys+i]=item.funcCode;
  payload[model.keys*2+i]=item.mediaExtraCode;
  if(item.funcCode===3&&item.stringCode)payload.set(Array.from(item.stringCode).slice(0,model.text),model.textOff+i*model.text);
  if(item.funcCode===2&&item.mixCode)payload.set(Array.from(item.mixCode).slice(0,5),model.mixOff+i*5);
 });
 payload[model.lightOff]=lighting.mode;
 for(let i=0;i<model.keys;i++)payload[model.lightOff+1+i]=lighting.colors[i];
 payload[model.brightnessOff]=lighting.brightness;
 if(model.knob){
  if(!Array.isArray(knobs)||knobs.length!==3)throw Error('旋钮配置不完整');
  const mixOffsets=[5,10,0];
  knobs.forEach((item,i)=>{
   const off=model.knobOff+i*3;
   payload[off]=item.key;payload[off+1]=item.func;payload[off+2]=item.extra;
   if(item.func===5&&item.mix)payload.set(Array.from(item.mix).slice(0,5),model.knobMixOff+mixOffsets[i]);
  });
 }
 codec.validate(type,payload);
 return payload;
}

function isModernReply(line){return typeof line==='string'&&line.indexOf('Q62:')===0;}

export {bytesToText,decodePayload,buildPayload,isModernReply};



// WEBPACK FOOTER //
// ./src/stability/legacy-bridge.js